import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/group',
  title: '拆解组管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
